(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-box-js"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-box-builder')) {
    const KEY = 'sf-box-v1';
    const money = (c) => '$' + (c / 100).toFixed(2);
    const calm = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class SfBox extends HTMLElement {
      connectedCallback() {
        this.tiers = JSON.parse(this.dataset.tiers).sort((a, b) => a.q - b.q);
        this.goal = Number(this.dataset.goal) || 12;
        this.ship = Number(this.dataset.ship) || 3499;
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.byId = {};
        this.cards.forEach((c) => (this.byId[c.dataset.id] = c));
        this.order = [];
        try {
          const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
          this.order = saved.filter((id) => this.byId[id] && !this.byId[id].classList.contains('is-out'));
        } catch (e) {}
        this.lastTier = this.tierIndex(this.order.length);
        this.addEventListener('click', (e) => this.onClick(e));
        this.render(false);
      }

      onClick(e) {
        const t = e.target.closest('button');
        if (!t || !this.contains(t)) return;
        const card = t.closest('[data-card]');
        if (t.hasAttribute('data-plus') && card) this.add(card.dataset.id);
        else if (t.hasAttribute('data-minus') && card) this.remove(card.dataset.id);
        else if (t.hasAttribute('data-chip')) this.filter(t);
        else if (t.hasAttribute('data-surprise')) this.surprise();
        else if (t.hasAttribute('data-clear')) { this.order = []; this.render(); }
        else if (t.hasAttribute('data-checkout')) this.checkout(t);
      }

      add(id, quiet) {
        this.order.push(id);
        this.render();
        const slot = this.querySelectorAll('[data-slot]')[Math.min(this.order.length, this.goal) - 1];
        if (slot && !calm()) { slot.classList.remove('pop'); void slot.offsetWidth; slot.classList.add('pop'); }
        const card = this.byId[id];
        if (card && !quiet && !calm()) { card.classList.remove('bump'); void card.offsetWidth; card.classList.add('bump'); }
      }

      remove(id) {
        const i = this.order.lastIndexOf(id);
        if (i > -1) this.order.splice(i, 1);
        this.render();
      }

      filter(chip) {
        this.querySelectorAll('[data-chip]').forEach((c) => c.classList.toggle('is-on', c === chip));
        const shelf = chip.dataset.chip;
        this.cards.forEach((c) => (c.hidden = shelf !== 'all' && c.dataset.shelf !== shelf));
      }

      surprise() {
        const n = this.order.length;
        const next = this.tiers.find((t) => t.q > n);
        const target = next ? next.q : n + 1;
        const pool = this.cards.filter((c) => !c.classList.contains('is-out')).map((c) => c.dataset.id);
        if (!pool.length) return;
        const picks = [];
        for (let i = n; i < target; i++) picks.push(pool[Math.floor(Math.random() * pool.length)]);
        picks.forEach((id, i) => setTimeout(() => this.add(id, false), calm() ? 0 : i * 160));
      }

      tierIndex(n) {
        let idx = -1;
        this.tiers.forEach((t, i) => { if (n >= t.q) idx = i; });
        return idx;
      }

      render(celebrate = true) {
        const n = this.order.length;
        const counts = {};
        this.order.forEach((id) => (counts[id] = (counts[id] || 0) + 1));
        try { localStorage.setItem(KEY, JSON.stringify(this.order)); } catch (e) {}

        this.cards.forEach((c) => {
          const q = counts[c.dataset.id] || 0;
          c.classList.toggle('is-in', q > 0);
          const badge = c.querySelector('[data-badge]');
          if (badge) { badge.hidden = !q; badge.textContent = '×' + q; }
          const lbl = c.querySelector('[data-addlabel]');
          if (lbl) lbl.textContent = q ? q : 'Add';
        });

        this.querySelectorAll('[data-slot]').forEach((slot, i) => {
          const id = this.order[i];
          const card = id && this.byId[id];
          slot.classList.toggle('is-full', !!card);
          slot.innerHTML = card ? `<img src="${card.dataset.img}" alt="${card.dataset.name}" width="80" height="80">` : '';
        });
        const extra = this.querySelector('[data-extra]');
        extra.hidden = n <= this.goal;
        extra.textContent = '+' + (n - this.goal) + ' more';
        this.querySelector('[data-count]').textContent = n;

        const ti = this.tierIndex(n);
        this.querySelectorAll('[data-tier]').forEach((el, i) => el.classList.toggle('is-on', i <= ti));
        const pct = ti > -1 ? this.tiers[ti].p : 0;
        const sub = this.order.reduce((s, id) => s + Number(this.byId[id].dataset.price), 0);
        const total = this.order.reduce((t, id) => { const p = Number(this.byId[id].dataset.price); return t + p - Math.floor((p * pct) / 100); }, 0);

        const next = this.tiers.find((t) => t.q > n);
        let msg;
        if (!n) msg = 'Add your first jar';
        else if (next) {
          const left = next.q - n;
          msg = `<b>${left} more jar${left > 1 ? 's' : ''}</b> ${left > 1 ? 'unlock' : 'unlocks'} ${next.p}% off`;
          if (ti > -1) msg = `${this.tiers[ti].p}% off unlocked! ` + msg;
        } else msg = `<b>${this.tiers[ti].n}!</b> ${pct}% off unlocked`;
        this.querySelector('[data-msg]').innerHTML = msg;
        this.querySelector('[data-fill]').style.width = Math.min(100, (n / this.goal) * 100) + '%';
        const all = (sel, fn) => this.querySelectorAll(sel).forEach(fn);
        all('[data-now]', (el) => this.tween(el, total));
        all('[data-was]', (el) => (el.textContent = pct ? money(sub) : ''));
        all('[data-checkout]', (b) => {
          b.disabled = !n;
          const big = b.classList.contains('sf-box__big');
          b.textContent = !n ? 'Pick your jars' : big ? `Add my box to cart · ${money(total)}` : `Add ${n} jar${n > 1 ? 's' : ''} to cart`;
        });
        const sp = Math.min(100, (total / this.ship) * 100);
        const away = this.ship - total;
        all('[data-ship-fill]', (el) => (el.style.width = sp + '%'));
        all('[data-truck]', (el) => (el.style.left = sp + '%'));
        const smsg = !n ? `Free shipping at ${money(this.ship)}` : away > 0 ? `🚚 <b>${money(away)}</b> away from free shipping` : '🚚 <b>Free shipping</b> unlocked!';
        all('[data-ship-msg]', (el) => (el.innerHTML = smsg));
        this.classList.toggle('is-ready', n >= this.goal);
        this.classList.toggle('is-shipfree', n > 0 && away <= 0);
        this.querySelector('[data-crate]').classList.toggle('is-full', n >= this.goal);
        this.prevAway = this.lastAway;
        if (celebrate && n && away <= 0 && this.lastAway > 0 && !(ti > this.lastTier)) this.toast('Free shipping', 'Your box ships free');
        this.lastAway = away;

        if (celebrate && ti > this.lastTier) this.confetti(this.tiers[ti]);
        this.lastTier = ti;
      }

      confetti(tier) {
        const box = this.querySelector('[data-confetti]');
        const shipNow = this.lastAway <= 0 && this.prevAway > 0;
        this.toast(`${tier.p}% off unlocked`, tier.n + (shipNow ? ' · ships free' : ''));
        if (calm()) return;
        const colors = ['#a42325', '#151311', '#faf7f2', '#e8a33d', '#c9a26b'];
        for (let i = 0; i < 70; i++) {
          const p = document.createElement('i');
          p.style.left = 50 + (Math.random() * 30 - 15) + '%';
          p.style.background = colors[i % colors.length];
          p.style.setProperty('--x', Math.random() * 120 - 60 + 'vw');
          p.style.setProperty('--y', Math.random() * -60 - 20 + 'vh');
          p.style.setProperty('--r', Math.random() * 720 - 360 + 'deg');
          p.style.animationDelay = Math.random() * 0.15 + 's';
          box.appendChild(p);
          setTimeout(() => p.remove(), 1800);
        }
      }

      toast(title, sub) {
        const box = this.querySelector('[data-confetti]');
        box.querySelectorAll('.sf-box__toast').forEach((t) => t.remove());
        const t = document.createElement('div');
        t.className = 'sf-box__toast';
        t.innerHTML = `<b>${title}</b><span>${sub}</span>`;
        box.appendChild(t);
        setTimeout(() => t.remove(), 2200);
      }

      tween(el, to) {
        const from = Number(el.dataset.v || 0);
        el.dataset.v = to;
        cancelAnimationFrame(el._raf);
        if (calm() || from === to) { el.textContent = money(to); return; }
        const t0 = performance.now();
        const step = (t) => {
          const k = Math.min(1, (t - t0) / 500);
          el.textContent = money(Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3))));
          if (k < 1) el._raf = requestAnimationFrame(step);
        };
        el._raf = requestAnimationFrame(step);
        el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick');
      }

      async checkout(btn) {
        const counts = {};
        this.order.forEach((id) => (counts[id] = (counts[id] || 0) + 1));
        const ids = Object.keys(counts);
        if (!ids.length) return;
        btn.disabled = true;
        btn.textContent = 'Packing your box…';
        const actions = window.Shopify?.actions;
        try {
          if (!actions?.updateCart) throw new Error('no actions');
          const r = await actions.updateCart({ lines: ids.map((id) => ({ merchandiseId: id, quantity: counts[id] })) }, { event: { context: 'collection' } });
          if (r?.userErrors?.length) throw new Error(r.userErrors[0].message);
          this.order = [];
          this.render(false);
          await actions.openCart?.();
        } catch (e) {
          try {
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: counts[id] })) }) });
            this.order = [];
            try { localStorage.removeItem(KEY); } catch (err) {}
            window.location.href = '/cart';
          } catch (err) {
            btn.disabled = false;
            this.render(false);
          }
        }
      }
    }
    customElements.define('sf-box-builder', SfBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-brujo-assets"] && !Shopify.designMode) return;
  try {
    if (!window.sfBrujoSticky) {
    window.sfBrujoSticky = true;
    const setup = () => {
      const hero = document.querySelector('[data-bj-hero]');
      const bar = document.querySelector('[data-bj-sticky]');
      if (!hero || !bar || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      const io = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-shown', !entry.isIntersecting);
      });
      io.observe(hero);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-prb-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-multi-add')) {
    customElements.define('sf-multi-add', class extends HTMLElement {
      connectedCallback() { this.addEventListener('submit', (e) => this.go(e)); }
      async go(e) {
        const form = e.target;
        const actions = window.Shopify?.actions;
        const ids = [...form.querySelectorAll('[data-line-id]')].map((i) => i.value).filter(Boolean);
        if (!(form instanceof HTMLFormElement) || !actions?.updateCart || !ids.length) return;
        e.preventDefault();
        const btn = form.querySelector('button');
        const label = btn.textContent;
        btn.disabled = true;
        try {
          const r = await actions.updateCart({ lines: ids.map((id) => ({ merchandiseId: id, quantity: 1 })) }, { event: { context: 'collection' } });
          if (r?.userErrors?.length) throw new Error(r.userErrors[0].message);
          btn.textContent = 'Added';
          await actions.openCart?.();
          setTimeout(() => { btn.textContent = label; }, 2500);
        } catch (err) {
          form.submit();
        } finally {
          btn.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
